






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {Auditoria} from '@/model/resource/Auditoria'
import {InputAuditoriaSchema} from '@/schema/resource/Auditoria/InputAuditoriaSchema'

@Component
export default class PersistAuditoriaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputAuditoriaSchema()
  auditoria = new Auditoria()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionAuditoriaMotivo.listAuditoriaMotivo()
    this.schema.collectionCarga.listCarga()
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.auditoria.getAuditoria(id)
    }

    $.await.done('getAuditoria')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.auditoria.persistAuditoria()
    await Helper.successAndPush('system.success.persist', '/auditoria/list')
  }
}
